import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import OrderModal from "../components/OrderModal";
import { useTranslation } from '../useTranslation';

const ProduitDetails = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const { t } = useTranslation();
  const { id } = useParams();
  const [product, setProduit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

 useEffect(() => {
  const fetchProduit = async () => {
    const { data, error } = await supabase
      .from('products')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      console.error('Erreur :', error);
    } else {
      setProduit(data);
      // Fetch related products randomly
      const { data: allProducts } = await supabase
        .from('products')
        .select('*')
        .neq('id', id);
      
      // Shuffle array and get first 3 elements
      const shuffled = allProducts.sort(() => 0.5 - Math.random());
      setRelatedProducts(shuffled.slice(0, 3) || []);
    }
    setLoading(false);
  };

  fetchProduit();
}, [id]);

  if (loading) return  <div className="text-center py-10">{t('loading')}</div>;
  if (!product) return <div className="text-center py-10 text-red-500">{t('productNotFound')}</div>;

  return (
    <>
    <style>{`
    body {     
      padding-top: 0px !important;
      background: #0c0b09;
    }
  `}</style>

      <div className="container-fluid py-5 section-bg" >
        <div className="row px-xl-5 "  style={{paddingTop: 140}}>
          {/* Product Images */}
          <div className="col-lg-5 pb-5" >
            <div id="productCarousel" className="carousel slide" data-bs-ride="carousel">
              <div className="carousel-inner border rounded-lg overflow-hidden">
                <div className="carousel-item active" data-bs-interval="3000">
                  <img 
                    className="w-100 h-100 object-cover" 
                    src={product.image_url} 
                    alt={product.name}
                    style={{ maxHeight: "500px" }}
                  />
                </div>
                {[2, 3, 4].map((num) => (
                  <div className="carousel-item" data-bs-interval="3000" key={num}>
                    <img 
                      className="w-100 h-100 object-cover" 
                      src={product.image_url} 
                      alt={`${product.name} ${num}`}
                      style={{ maxHeight: "500px" }}
                    />
                  </div>
                ))}
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#productCarousel" data-bs-slide="prev">
  <span 
    className="carousel-control-prev-icon" 
    style={{ width: "15px", height: "15px", backgroundSize: "100% 100%" }} 
    aria-hidden="true">
  </span>
</button>
<button className="carousel-control-next" type="button" data-bs-target="#productCarousel" data-bs-slide="next">
  <span 
    className="carousel-control-next-icon" 
    style={{ width: "15px", height: "15px", backgroundSize: "100% 100%" }} 
    aria-hidden="true">
  </span>
</button>
            </div>
          </div>

          {/* Product Details */}
          <div className="col-lg-7 pb-5">
            <h1 className="font-weight-semi-bold mb-3 text-3xl">{product.name}</h1>
            
            <div className="d-flex align-items-center mb-3">
              <div className="text-yellow-400 mr-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i 
                    key={star} 
                    className={`fas fa-star ${star <= 4 ? 'text-yellow-400' : 'text-gray-300'}`}
                  ></i>
                ))}
              </div>
              <small className="text-gray-500">(50 Avis)</small>
            </div>

            <h2 className="font-weight-semi-bold mb-4 text-2xl" style={{ color: '#cda45e' }}>{product.price} DT</h2>
            
            <p className="mb-4 text-gray-700">{product.description || "Description détaillée du produit."}</p>

            {/* Size Selection */}
            <div className="d-flex mb-4">
              <p className="font-weight-medium mb-0 mr-3 text-gray-700">Poids</p>
              <div className="d-flex flex-wrap">
                {['1 KG', '2 KG', '3 KG', '4 KG', '5 KG'].map((size) => (
                  <button 
                    key={size}
                    className="btn btn-outline-secondary btn-sm mx-1 mb-1"
                    style={{ borderColor: '#cda45e', color: '#cda45e' }}
                  >
                    {size}
                  </button>
                ))}
              </div>
            </div>

            {/* Color Selection */}
            <div className="d-flex mb-4">
              <p className="font-weight-medium mb-0 mr-3 text-gray-700">Couleurs:</p>
              <div className="d-flex flex-wrap">
                {['Noir', 'Blanc', 'Rouge', 'Bleu', 'Vert'].map((color) => (
                  <button 
                    key={color}
                    className="btn btn-outline-secondary btn-sm mx-1 mb-1"
                    style={{ borderColor: '#cda45e', color: '#cda45e' }}
                  >
                    {color}
                  </button>
                ))}
              </div>
            </div>

            {/* Order Button */}
            <div className="col-12 text-center mt-4">
                              <Link onClick={() => setIsModalOpen(true)} className="btn-explore-more">
                                <i className="bi-cart"></i> {t('orderButton')}
                              </Link>
                            </div>
            {/* Social Sharing 
            <div className="d-flex pt-2">
              <p className="font-weight-medium mb-0 mr-2 text-gray-700">Partager:</p>
              <div className="d-inline-flex">
                {['facebook-f', 'twitter', 'linkedin-in', 'pinterest'].map((social) => (
                  <a 
                    key={social}
                    className="text-gray-600 hover:text-primary px-2" 
                    href="#"
                  >
                    <i className={`fab fa-${social}`}></i>
                  </a>
                ))}
              </div>
            </div> */}
          </div>
        </div>
      </div>

<section id="specials" className="specials">
  <div className="container" data-aos="fade-up">
    <div className="section-title">
      <h2>{t('productDetails')}</h2>
      <p>{t('productDescription')}</p>
    </div>
    <div className="row" data-aos="fade-up" data-aos-delay="100">
      <div className="col-lg-3">
        <ul className="nav nav-tabs flex-column">
          {[1, 2, 3].map((tab) => (
            <li className="nav-item" key={tab}>
              <a 
                className={`nav-link ${tab === 1 ? 'active show' : ''}`}
                data-bs-toggle="tab" 
                href={`#tab-${tab}`}
              >
                {tab === 1 &&  t('tabDescription')}
                {tab === 2 && t('tabInfo')}
                {tab === 3 && t('tabReviews')}
              </a>
            </li>
          ))}
        </ul>
      </div>
      
      <div className="col-lg-9 mt-4 mt-lg-0">
        <div className="tab-content">
          {[1, 2, 3].map((tab) => (
            <div 
              className={`tab-pane ${tab === 1 ? 'active show' : ''}`} 
              id={`tab-${tab}`} 
              key={tab}
            >
              <div className="row">
                <div className="col-lg-8 details order-2 order-lg-1">
                  <h3>
                    {tab === 1 && t('productDescriptionTitle')}
                    {tab === 2 && t('additionalInfoTitle')}
                    {tab === 3 && t('reviewsTitle')}
                  </h3>
                  <p style={{ whiteSpace: 'pre-line' }}>
                    {tab === 1 && t('productDescriptionTitle')}
                    {tab === 2 && t('additionalInfoText')}
                    {tab === 3 && t('reviewsText')}
                  </p>
                </div>
                <div className="col-lg-4 text-center order-1 order-lg-2">
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</section>

      {/* Related Products */}
      <section id="related-products" className="products section-bg">
  <div className="container" data-aos="fade-up">
    <div className="section-title">
      <h2>{t('similarProductsTitle')}</h2>
      <p>{t('similarProductsSubtitle')}</p>
    </div>

    <div className="row">
      {relatedProducts.length > 0 ? (
        relatedProducts.map((product, index) => (
          <div
            className="col-lg-4 col-md-6"
            key={product.id}
            data-aos="zoom-in"
            data-aos-delay={100 * index}
          >
            <div className="member">
              <div className="img-container">
                <img
                  src={product.image_url}
                  className="img-fluid"
                  alt={product.name}
                  style={{
                    width: '100%',
                    height: '300px',
                    objectFit: 'cover'
                  }}
                />
                <div className="member-info">
                  <div className="member-info-content">
                    <h4>{product.name}</h4>
                    <span>{product.price} DT</span>
                  </div>
                  <div className="social">
                    <Link
                      to={`/produitDetails/${product.id}`}
                      onClick={scrollToTop}
                      className="btn-details"
                    >
                      <i className="bi bi-eye"></i> {t('viewDetails')}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="col-12 text-center py-4">
          <p className="lead">{t('noProducts')}</p>
        </div>
      )}
    </div>
  </div>
</section>

      {/* Order Modal */}
      <OrderModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        product={product}
      />
    </>
  );
};

export default ProduitDetails;